import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { auth } from "../../firebase.js";
import "./sideBar.css"

function SideBar({ isMobileView = false, isSidebarOpen = true, onCloseSidebar = () => {} }){
    const [claims, setClaims] = useState({});

    useEffect(() => {
        // Listen for auth state changes
        const unsubscribe = auth.onAuthStateChanged(async (user) => {
            if (user) {
                // Force refresh token to get latest claims
                await user.getIdToken(true);
                const tokenResult = await user.getIdTokenResult();
                setClaims(tokenResult.claims || {});
            } else {
                setClaims({});
            }
        });

        return () => unsubscribe();
    }, []);

    const sidebarClassName = [
        "sidebar",
        isMobileView ? "sidebar-mobile" : "",
        isSidebarOpen ? "sidebar-open" : ""
    ].join(" ").trim();

    const handleNavClick = () => {
        if (isMobileView) {
            onCloseSidebar();
        }
    };

    return(
        <>
            <div className={sidebarClassName}>
                <div className="sidebar-header">
                    <h3 className="sidebar-title">Navigation</h3>
                </div>
                
                <nav className="sidebar-nav">
                    <div className="nav-section">
                        <h4 className="nav-section-title">Main</h4>
                        
                        {/* Admin-only navigation */}
                        {claims.admin && (
                            <>
                                <Link to="/admin" className="nav-link" onClick={handleNavClick}>
                                    <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M9 12h6m-6 4h6m2 5H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5.586a1 1 0 0 1 .707.293l5.414 5.414a1 1 0 0 1 .293.707V19a2 2 0 0 1-2 2z"/>
                                    </svg>
                                    <span>Orders</span>
                                </Link>
                                <Link to="/admin/active-alterations" className="nav-link" onClick={handleNavClick}>
                                    <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                                        <path d="M8 12l2 2 4-4"/>
                                    </svg>
                                    <span>Active Alterations</span>
                                </Link>
                                <Link to="/admin/push-notifications" className="nav-link" onClick={handleNavClick}>
                                    <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9"/>
                                        <path d="M13.73 21a2 2 0 0 1-3.46 0"/>
                                    </svg>
                                    <span>Push Notifications</span>
                                </Link>
                                <Link to="/admin/customers" className="nav-link" onClick={handleNavClick}>
                                    <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
                                        <circle cx="12" cy="7" r="4"/>
                                    </svg>
                                    <span>Customers</span>
                                </Link>
                                <Link to="/admin/users" className="nav-link" onClick={handleNavClick}>
                                    <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
                                        <circle cx="9" cy="7" r="4"/>
                                        <path d="M23 21v-2a4 4 0 0 0-3-3.87"/>
                                        <path d="M16 3.13a4 4 0 0 1 0 7.75"/>
                                    </svg>
                                    <span>Users</span>
                                </Link>
                                <Link to="/admin/marketing" className="nav-link" onClick={handleNavClick}>
                                    <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M3 11l18-5v12L3 14v-3z"/>
                                        <path d="M11.6 16.8a3 3 0 1 1-5.8-1.6"/>
                                    </svg>
                                    <span>SMS Marketing</span>
                                </Link>
                                <Link to="/admin/email-marketing" className="nav-link" onClick={handleNavClick}>
                                    <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
                                        <polyline points="22,6 12,13 2,6"/>
                                    </svg>
                                    <span>Email Marketing</span>
                                </Link>
                                
                            </>
                        )}
                        
                        {/* User-only navigation */}
                        {claims.user && (
                            <>
                                <Link to="/user" className="nav-link" onClick={handleNavClick}>
                                    <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M9 12h6m-6 4h6m2 5H7a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h5.586a1 1 0 0 1 .707.293l5.414 5.414a1 1 0 0 1 .293.707V19a2 2 0 0 1-2 2z"/>
                                    </svg>
                                    <span>Orders</span>
                                </Link>
                                <Link to="/user/my-orders" className="nav-link" onClick={handleNavClick}>
                                    <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2"/>
                                        <rect x="8" y="2" width="8" height="4" rx="1" ry="1"/>
                                        <path d="M12 11h4"/>
                                        <path d="M12 16h4"/>
                                        <path d="M8 11h.01"/>
                                        <path d="M8 16h.01"/>
                                    </svg>
                                    <span>My Orders</span>
                                </Link>
                                <Link to="/user" state={{ openReceiptLookup: true }} className="nav-link" onClick={handleNavClick}>
                                    <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                        <circle cx="11" cy="11" r="8"/>
                                        <path d="m21 21-4.35-4.35"/>
                                    </svg>
                                    <span>Look up</span>
                                </Link>
                            </>
                        )}
                    </div>
                    
                    {/* Admin-only rewards section */}
                    {claims.admin && (
                        <div className="nav-section">
                            <h4 className="nav-section-title">Rewards</h4>
                            <Link to="/admin/rewards" className="nav-link" onClick={handleNavClick}>
                                <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <path d="M20 12v8a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2v-8"/>
                                    <path d="M2 7h20v5H2z"/>
                                    <path d="M12 22V7"/>
                                    <path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"/>
                                    <path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"/>
                                </svg>
                                <span>Rewards</span>
                            </Link>
                            <Link to="/admin/rewards/events" className="nav-link" onClick={handleNavClick}>
                                <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <circle cx="12" cy="12" r="9"/>
                                    <path d="M12 7v5l3 2"/>
                                </svg>
                                <span>Point events</span>
                            </Link>
                            <Link to="/admin/rewards/ledger" className="nav-link" onClick={handleNavClick}>
                                <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <path d="M4 19.5A2.5 2.5 0 0 1 6.5 17H20"/>
                                    <path d="M6.5 2H20v20H6.5A2.5 2.5 0 0 1 4 19.5v-15A2.5 2.5 0 0 1 6.5 2z"/>
                                    <path d="M8 7h8"/>
                                    <path d="M8 11h8"/>
                                    <path d="M8 15h5"/>
                                </svg>
                                <span>Ledger</span>
                            </Link>
                        </div>
                    )}

                    {/* Admin-only system section */}
                    {claims.admin && (
                        <div className="nav-section">
                            <h4 className="nav-section-title">System</h4>
                            <Link to="/admin/settings" className="nav-link" onClick={handleNavClick}>
                                <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <circle cx="12" cy="12" r="3"/>
                                    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-2 2 2 2 0 0 1-2-2v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83 0 2 2 0 0 1 0-2.83l.06-.06a1.65 1.65 0 0 0 .33-1.82 1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1-2-2 2 2 0 0 1 2-2h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 1.82.33H9a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 2-2 2 2 0 0 1 2 2v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 0 2 2 0 0 1 0 2.83l-.06.06a1.65 1.65 0 0 0-.33 1.82V9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 2 2 2 2 0 0 1-2 2h-.09a1.65 1.65 0 0 0-1.51 1z"/>
                                </svg>
                                <span>Settings</span>
                            </Link>
                            <Link to="/admin/reports" className="nav-link" onClick={handleNavClick}>
                                <svg className="nav-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                                    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/>
                                    <polyline points="14,2 14,8 20,8"/>
                                    <line x1="16" y1="13" x2="8" y2="13"/>
                                    <line x1="16" y1="17" x2="8" y2="17"/>
                                    <polyline points="10,9 9,9 8,9"/>
                                </svg>
                                <span>Reports</span>
                            </Link>
                        </div>
                    )}
                </nav>
                
                <div className="sidebar-footer">
                    <div className="sidebar-info">
                        <p className="sidebar-version">v1.0.0</p>
                        <p className="sidebar-status">System Online</p>
                    </div>
                </div>
            </div>
        </>
    );
}

export default SideBar